import { Observable } from 'rxjs';
import { ChatConversation, ChatParticipantInfo } from '../chat-model.interface';

export abstract class ChatEngineChannelsService {
  public abstract get initialConversationsListLoaded(): Observable<ChatConversation[]>;
  public abstract get conversationsListChanged(): Observable<ChatConversation[]>;
  public abstract get conversationJoined(): Observable<ChatConversation>;
  public abstract get conversationRemoved(): Observable<ChatConversation>;
  public abstract get conversationRenamed(): Observable<ChatConversation>;
  public abstract get participantJoined(): Observable<ChatParticipantInfo>;
  public abstract get participantLeft(): Observable<ChatParticipantInfo>;

  public abstract getConversationByUniqueName(channelUniqueName: string): Promise<ChatConversation>;
}
